'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;
// styled


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getNested = require('get-nested');

var _getNested2 = _interopRequireDefault(_getNested);

var _Parser = require('../Parser');

var _Parser2 = _interopRequireDefault(_Parser);

var _WebformElement = require('../WebformElement');

var _WebformElement2 = _interopRequireDefault(_WebformElement);

var _Field = require('../Observables/Field');

var _Field2 = _interopRequireDefault(_Field);

var _Fieldset = require('../Fieldset');

var _Fieldset2 = _interopRequireDefault(_Fieldset);

var _wrapper = require('./styled/wrapper');

var _wrapper2 = _interopRequireDefault(_wrapper);

var _radioLabel = require('./styled/radio-label');

var _radioLabel2 = _interopRequireDefault(_radioLabel);

var _radio = require('./styled/radio');

var _radio2 = _interopRequireDefault(_radio);

var _indicator = require('./styled/indicator');

var _indicator2 = _interopRequireDefault(_indicator);

var _wrapper3 = require('../Fieldset/styled/wrapper');

var _wrapper4 = _interopRequireDefault(_wrapper3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RadioField = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(RadioField, _Component);

  function RadioField() {
    (0, _classCallCheck3.default)(this, RadioField);
    return (0, _possibleConstructorReturn3.default)(this, (RadioField.__proto__ || (0, _getPrototypeOf2.default)(RadioField)).apply(this, arguments));
  }

  (0, _createClass3.default)(RadioField, [{
    key: 'getOptionPositionDisplay',
    value: function getOptionPositionDisplay() {
      return this.props.field['#options_display'];
    }
  }, {
    key: 'getLabelPositionDisplay',
    value: function getLabelPositionDisplay() {
      return this.props.field['#title_display'];
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var wrapperAttrs = {
        'aria-invalid': this.props.webformElement.isValid() ? null : true,
        'aria-required': this.props.field['#required'] ? true : null
      };

      return _react2.default.createElement(
        _wrapper2.default,
        (0, _extends3.default)({
          role: 'radiogroup'
        }, wrapperAttrs, {
          labelDisplay: this.getLabelPositionDisplay()
        }),
        (0, _getNested2.default)(function () {
          return _this2.props.field['#options'];
        }, []).map(function (option, index) {
          var labelKey = _this2.props.field['#webform_key'] + '_' + index;
          return _react2.default.createElement(
            _radioLabel2.default,
            {
              key: option.value,
              htmlFor: labelKey,
              optionDisplay: _this2.getOptionPositionDisplay()
            },
            _react2.default.createElement(_radio2.default, {
              type: 'radio',
              onChange: _this2.props.onChange,
              onBlur: _this2.props.onBlur,
              value: option.value,
              name: _this2.props.field['#webform_key'],
              id: labelKey,
              disabled: !_this2.props.state.enabled,
              checked: _this2.props.value === option.value.toString()
            }),
            _react2.default.createElement(_indicator2.default, null),
            (0, _Parser2.default)(option.text)
          );
        })
      );
    }
  }]);
  return RadioField;
}(_react.Component), _class.meta = {
  wrapper: _wrapper4.default,
  label: _Fieldset2.default.meta.label,
  wrapperProps: _Fieldset2.default.meta.wrapperProps
}, _class.propTypes = {
  field: _propTypes2.default.shape({
    '#required': _propTypes2.default.bool,
    '#options': _propTypes2.default.arrayOf(_propTypes2.default.shape({
      value: _propTypes2.default.node,
      text: _propTypes2.default.node
    })),
    '#webform_key': _propTypes2.default.string.isRequired,
    '#title_display': _propTypes2.default.string,
    '#options_display': _propTypes2.default.string
  }).isRequired,
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.bool]).isRequired,
  webformElement: _propTypes2.default.instanceOf(_WebformElement2.default).isRequired,
  onChange: _propTypes2.default.func.isRequired,
  onBlur: _propTypes2.default.func.isRequired,
  state: _propTypes2.default.instanceOf(_Field2.default).isRequired
}, _temp);
exports.default = RadioField;